import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import GuardDutyDetailBody from '../GuardDutyDetailBody';

export const guarddutyEngine = {
  id: 'guardduty',
  label: 'GuardDuty',
  color: '#E65100',
  Icon: GppMaybeIcon,
  capability: {
    name: 'Threat detection',
    source: 'Amazon GuardDuty',
    description: 'Continuous threat detection across accounts and workloads.',
    items: ['EC2/EKS/S3/Lambda/RDS threat detection', 'Malware Protection', 'Runtime Monitoring'],
  },
  nav: [
    { label: 'Threats', to: '/securityhub/guardduty' },
    { label: 'Findings', to: '/securityhub/guardduty/findings' },
    { label: 'Enrollment', to: '/securityhub/guardduty/enrollment' },
    { label: 'Settings', to: '/securityhub/guardduty/settings' },
  ],
  enableRoute: '/securityhub/guardduty',
  DetailBody: GuardDutyDetailBody,
};
